import { render } from "./MessageShow.vue?vue&type=template&id=07370d9e&scoped=true"
import script from "./MessageShow.vue?vue&type=script&lang=js"
export * from "./MessageShow.vue?vue&type=script&lang=js"

import "./MessageShow.vue?vue&type=style&index=0&id=07370d9e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07370d9e"]])

export default __exports__